import { sharedWorkforceService } from 'api/services';
import { useMutation } from 'react-query';

export const useResendEmployeeTemporaryPassword = () => {
  const mutationFn = async (employeeEmail: string) =>
    await sharedWorkforceService.resendTemporaryPassword(employeeEmail);

  return useMutation(mutationFn);
};
